// ... existing imports ...
import { formatPercent, formatThousands, isNullOrUndefined } from '.';

interface ROIValues {
  projectedReturnOnInvestment: number;
  projectedCompoundAnnualGrowthRate: number;
  projectedInternalRateOfReturn: number | undefined;
  investmentPeriodYears: number;
}

export function formatROI(
  values: ROIValues,
  calculationType: ReturnOnInvestmentCalculationType | undefined,
): string {
  const formatPercentToTwoDecimals = (value: number) => formatPercent(value, 2);
  const formatYears = (years: number) =>
    `${formatThousands(years, '0', 1)} ${years === 1 ? 'yr' : 'yrs'}`;

  switch (calculationType) {
    case 'compoundAnnualGrowthRate':
      return `${formatPercentToTwoDecimals(values.projectedCompoundAnnualGrowthRate)} (${formatYears(values.investmentPeriodYears)})`;
    case 'internalRateOfReturn':
      if (isNullOrUndefined(values.projectedInternalRateOfReturn)) {
        return 'Not calculable';
      }
      return `${formatPercentToTwoDecimals(values.projectedInternalRateOfReturn)} (${formatYears(values.investmentPeriodYears)})`;
    case 'total':
    default:
      return formatPercentToTwoDecimals(values.projectedReturnOnInvestment);
  }
}

export function getROILabel(
  calculationType: ReturnOnInvestmentCalculationType | undefined,
): string {
  switch (calculationType) {
    case 'internalRateOfReturn':
      return 'Annual IRR';
    case 'compoundAnnualGrowthRate':
      return 'Annual ROI';
    case 'total':
    default:
      return 'Total ROI';
  }
}
